import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { CustomIconService } from 'src/app/core/services/custom-icon.service';
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';
import { Router, NavigationEnd } from '@angular/router';
import { DataLayerService } from 'src/app/core/services/data-layer.service';

@Component({
  selector: '[toast-component]',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})

export class ToasterComponent extends Toast implements AfterViewInit {
  copied: boolean = false;
  toggleTooltip: boolean = false;
  copyContent: string;
  @ViewChild('toastBox') toastBox: ElementRef;
  @ViewChild('messageContainer') messageContainer: ElementRef;

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
    private customIconService: CustomIconService,
    private router: Router,
    private _dataLayerService: DataLayerService,
    private changeDetector: ChangeDetectorRef
  ) {
    super(toastrService, toastPackage);
  }

  ngOnInit(): void {
    this.customIconService.init();
    if (this.toastPackage.toastType != 'toast-error') {
      setTimeout(() => {
        this.toastBox.nativeElement.click();
      }, 4000);
    }

    setTimeout(() => {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.toastBox.nativeElement.click();
        }
      });
    }, 4000);

    if (this.toastPackage.toastType == 'toast-error') {
      this._dataLayerService.logEvent('toast', 'error', 'toast', this.toastPackage.message);
    }
  }

  ngAfterViewInit() {
    this.copyContent = this.options.enableHtml ? this.messageContainer?.nativeElement.textContent : this.message;
    this.changeDetector.detectChanges();
  }

  copy(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 500);

  }
}
